document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('header.header');
  let lastScrollTop = 0;

  window.addEventListener('scroll', function() {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;
    
    if (scrollTop > lastScrollTop) {
      header.classList.add('hide-on-scroll');
    } else {
      header.classList.remove('hide-on-scroll');
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });
});
